import React from 'react';
import { CheckCircle2, Zap, Users, DollarSign, Clock, Shield, TrendingUp, ArrowRight, Bot, FileText, Calendar, CreditCard, MessageSquare, BarChart3, Megaphone, Target, Rocket, Building2 } from 'lucide-react';

const MillionDollarSoftwarePage = () => {
  const paymentLink = "https://thecollinswealthcollection.myshopify.com/products/the-wealth-scale-system?variant=45677607878713";

  return (
    <div className="dark-page">
      {/* Hero Section */}
      <section className="tradelines-hero" style={{ paddingBottom: '60px' }}>
        <div className="tradelines-hero-content">
          <div className="tradelines-badge">BUSINESS OPPORTUNITY</div>
          <h1 className="display-huge tradelines-title">
            <span className="text-gradient">Million Dollar</span> Software
          </h1>
          <p className="body-large tradelines-subtitle" style={{ maxWidth: '900px', margin: '0 auto 30px' }}>
            Build. Launch. Scale — Without Manual Disputes or Paperwork.
            We build you a fully automated AI-powered credit repair & funding website that runs your business for you.
          </p>
          
          <div className="tradelines-features-row" style={{ marginBottom: '40px' }}>
            <div className="tradeline-feature-item">
              <Bot size={24} />
              <span>Fully Automated</span>
            </div>
            <div className="tradeline-feature-item">
              <Clock size={24} />
              <span>Runs 24/7</span>
            </div>
            <div className="tradeline-feature-item">
              <DollarSign size={24} />
              <span>Scale Without Limits</span>
            </div>
          </div>
        </div>
      </section>

      {/* The Math Section */}
      <section className="wealth-for-section" style={{ background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.1) 0%, rgba(26, 10, 46, 0.95) 100%)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">The Path to <span className="text-gradient">$100K Months</span></h2>
          <p className="body-medium section-description" style={{ maxWidth: '800px', margin: '0 auto' }}>
            Simple math: Get 1,000 clients paying you $100/month = $100,000/month recurring revenue.
            Our system is designed to help you get there.
          </p>
        </div>
        
        <div className="stats-grid" style={{ marginTop: '40px' }}>
          <div className="stat-card">
            <div className="stat-value" style={{ color: 'var(--accent-gold)' }}>1,000</div>
            <div className="stat-label">Clients at $100/mo</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: 'var(--accent-gold)' }}>=</div>
            <div className="stat-label">Equals</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: 'var(--accent-gold)' }}>$100K</div>
            <div className="stat-label">Monthly Revenue</div>
          </div>
          <div className="stat-card">
            <div className="stat-value" style={{ color: 'var(--accent-gold)' }}>$1.2M</div>
            <div className="stat-label">Per Year</div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section className="wealth-for-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header">
          <h2 className="display-medium section-title">Stop Doing Everything Manually</h2>
          <p className="body-medium section-description">
            If you're running a credit repair or funding business, you're probably drowning in:
          </p>
        </div>
        
        <div className="wealth-for-grid" style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Printing and mailing dispute letters</span>
          </div>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Manually tracking every client's progress</span>
          </div>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Chasing follow-ups and missing deadlines</span>
          </div>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Answering the same questions over and over</span>
          </div>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Managing everything by hand with spreadsheets</span>
          </div>
          <div className="wealth-for-item" style={{ background: 'rgba(255,100,100,0.1)', borderColor: 'rgba(255,100,100,0.3)' }}>
            <span style={{ color: '#ff6b6b', fontSize: '24px', marginRight: '12px' }}>✗</span>
            <span>Working IN your business instead of ON it</span>
          </div>
        </div>
      </section>

      {/* Buy Now CTA */}
      <section style={{ padding: '40px 7.6923%', textAlign: 'center', background: 'var(--bg-primary)' }}>
        <a 
          href={paymentLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-primary"
          style={{ fontSize: '20px', padding: '20px 50px' }}
        >
          Buy Now <ArrowRight size={24} />
        </a>
      </section>

      {/* Solution Section */}
      <section className="wealth-included-section">
        <div className="section-header">
          <h2 className="display-medium section-title">What We Build For You</h2>
          <p className="body-medium section-description">
            A complete done-for-you AI system that handles EVERYTHING automatically
          </p>
        </div>
        
        <div className="wealth-included-grid">
          {/* Automated Credit Repair Platform */}
          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <FileText size={32} />
            </div>
            <h3 className="wealth-included-title">Automated Credit Repair Platform</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> AI-generated dispute letters customized for each client</li>
              <li><CheckCircle2 size={16} /> Smart compliance-based workflows that follow regulations</li>
              <li><CheckCircle2 size={16} /> Auto-timed follow-ups so nothing falls through cracks</li>
              <li><CheckCircle2 size={16} /> Client portal for document uploads and progress tracking</li>
              <li><CheckCircle2 size={16} /> Automated bureau communication and response handling</li>
            </ul>
          </div>

          {/* AI Clone of YOU */}
          <div className="wealth-included-card" style={{ borderColor: 'var(--accent-gold)', borderWidth: '2px' }}>
            <div className="wealth-included-icon" style={{ background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Bot size={32} />
            </div>
            <h3 className="wealth-included-title">AI Clone of YOU <span style={{ color: 'var(--accent-gold)', fontSize: '14px' }}>(Your Digital Sales Machine)</span></h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> We create an AI-powered version of YOU</li>
              <li><CheckCircle2 size={16} /> Speaks like you — trained on your voice & style</li>
              <li><CheckCircle2 size={16} /> Educates like you — delivers your knowledge 24/7</li>
              <li><CheckCircle2 size={16} /> Sells like you — closes deals while you sleep</li>
              <li><CheckCircle2 size={16} /> Scale your voice and brand without being present</li>
            </ul>
          </div>

          {/* Automated Content Distribution */}
          <div className="wealth-included-card" style={{ borderColor: 'var(--accent-gold)', borderWidth: '2px' }}>
            <div className="wealth-included-icon" style={{ background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Megaphone size={32} />
            </div>
            <h3 className="wealth-included-title">Automated Content Distribution System</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Deploy your brand across 200+ social media accounts</li>
              <li><CheckCircle2 size={16} /> Up to 1,000 posts per day — fully automated</li>
              <li><CheckCircle2 size={16} /> Over 30,000 posts per month</li>
              <li><CheckCircle2 size={16} /> Engineered to generate MILLIONS of impressions</li>
              <li><CheckCircle2 size={16} /> Drive mass awareness and inbound traffic automatically</li>
            </ul>
          </div>

          {/* Lead Generation + Conversion */}
          <div className="wealth-included-card" style={{ borderColor: 'var(--accent-gold)', borderWidth: '2px' }}>
            <div className="wealth-included-icon" style={{ background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Target size={32} />
            </div>
            <h3 className="wealth-included-title">Lead Generation + Conversion Infrastructure</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Capture leads automatically from all traffic sources</li>
              <li><CheckCircle2 size={16} /> Nurture prospects with automated follow-up sequences</li>
              <li><CheckCircle2 size={16} /> Convert traffic into paying clients on autopilot</li>
              <li><CheckCircle2 size={16} /> Create recurring monthly revenue streams</li>
              <li><CheckCircle2 size={16} /> Everything optimized for SCALING, not just launching</li>
            </ul>
          </div>

          {/* Done-For-You Website + CRM */}
          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <BarChart3 size={32} />
            </div>
            <h3 className="wealth-included-title">Done-For-You Website + CRM</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> High-converting professional website</li>
              <li><CheckCircle2 size={16} /> Booking and onboarding system</li>
              <li><CheckCircle2 size={16} /> Payment processing fully integrated</li>
              <li><CheckCircle2 size={16} /> Contract and e-sign automation</li>
              <li><CheckCircle2 size={16} /> Complete CRM for client management</li>
            </ul>
          </div>

          {/* AI Client Manager */}
          <div className="wealth-included-card">
            <div className="wealth-included-icon">
              <MessageSquare size={32} />
            </div>
            <h3 className="wealth-included-title">AI Client Manager (24/7)</h3>
            <ul className="wealth-included-list">
              <li><CheckCircle2 size={16} /> Auto-responds to all leads instantly</li>
              <li><CheckCircle2 size={16} /> Sends updates to clients automatically</li>
              <li><CheckCircle2 size={16} /> Handles FAQs without your involvement</li>
              <li><CheckCircle2 size={16} /> Books consultations on your calendar</li>
              <li><CheckCircle2 size={16} /> Qualifies leads before they reach you</li>
            </ul>
          </div>
        </div>
      </section>

      {/* The Outcome Section */}
      <section className="wealth-why-section" style={{ background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, rgba(26, 10, 46, 0.98) 100%)', padding: '80px 7.6923%' }}>
        <div className="section-header">
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>💰</div>
          <h2 className="display-medium section-title">The Outcome</h2>
          <p className="body-large section-description" style={{ maxWidth: '800px', margin: '0 auto' }}>
            This system is designed to help you achieve:
          </p>
        </div>
        
        <div className="wealth-included-grid" style={{ maxWidth: '1000px', margin: '40px auto' }}>
          <div className="wealth-included-card" style={{ textAlign: 'center', background: 'rgba(212, 175, 55, 0.1)', borderColor: 'var(--accent-gold)' }}>
            <div className="wealth-included-icon" style={{ margin: '0 auto 20px', background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <TrendingUp size={32} />
            </div>
            <h3 className="wealth-included-title" style={{ color: 'var(--accent-gold)' }}>Build a 6-7 Figure Business</h3>
            <p style={{ color: 'var(--text-secondary)' }}>Create a credit/funding empire that generates serious revenue</p>
          </div>

          <div className="wealth-included-card" style={{ textAlign: 'center', background: 'rgba(212, 175, 55, 0.1)', borderColor: 'var(--accent-gold)' }}>
            <div className="wealth-included-icon" style={{ margin: '0 auto 20px', background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Users size={32} />
            </div>
            <h3 className="wealth-included-title" style={{ color: 'var(--accent-gold)' }}>Consistent Inbound Leads Daily</h3>
            <p style={{ color: 'var(--text-secondary)' }}>Wake up to new prospects every single day</p>
          </div>

          <div className="wealth-included-card" style={{ textAlign: 'center', background: 'rgba(212, 175, 55, 0.1)', borderColor: 'var(--accent-gold)' }}>
            <div className="wealth-included-icon" style={{ margin: '0 auto 20px', background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Clock size={32} />
            </div>
            <h3 className="wealth-included-title" style={{ color: 'var(--accent-gold)' }}>Minimal Manual Effort</h3>
            <p style={{ color: 'var(--text-secondary)' }}>Operate your business without being tied to it</p>
          </div>

          <div className="wealth-included-card" style={{ textAlign: 'center', background: 'rgba(212, 175, 55, 0.1)', borderColor: 'var(--accent-gold)' }}>
            <div className="wealth-included-icon" style={{ margin: '0 auto 20px', background: 'linear-gradient(135deg, var(--accent-gold) 0%, #f4d03f 100%)' }}>
              <Building2 size={32} />
            </div>
            <h3 className="wealth-included-title" style={{ color: 'var(--accent-gold)' }}>$5M - $10M Exit Potential</h3>
            <p style={{ color: 'var(--text-secondary)' }}>Position your company as a valuable, sellable asset</p>
          </div>
        </div>
      </section>

      {/* Who This Is For */}
      <section className="wealth-for-section">
        <div className="section-header">
          <h2 className="display-medium section-title">Who This Is For</h2>
          <p className="body-medium section-description">
            This system is built for entrepreneurs ready to scale
          </p>
        </div>
        
        <div className="wealth-for-grid">
          <div className="wealth-for-item">
            <Users size={20} />
            <span>Credit repair business owners</span>
          </div>
          <div className="wealth-for-item">
            <Users size={20} />
            <span>Coaches & consultants in the credit space</span>
          </div>
          <div className="wealth-for-item">
            <Users size={20} />
            <span>People starting a credit repair company</span>
          </div>
          <div className="wealth-for-item">
            <Users size={20} />
            <span>Funding & business credit professionals</span>
          </div>
          <div className="wealth-for-item">
            <Users size={20} />
            <span>Entrepreneurs tired of manual systems</span>
          </div>
          <div className="wealth-for-item">
            <Users size={20} />
            <span>Anyone who wants to build a credit empire</span>
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="stats-section" style={{ background: 'var(--bg-secondary)' }}>
        <div className="section-header" style={{ marginBottom: '40px' }}>
          <h2 className="display-medium section-title">Results You Get</h2>
        </div>
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-value">24/7</div>
            <div className="stat-label">Your Business Runs Around The Clock</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">0</div>
            <div className="stat-label">Staff Needed To Scale</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">10x</div>
            <div className="stat-label">More Clients With Less Work</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">100%</div>
            <div className="stat-label">Compliant & Professional</div>
          </div>
        </div>
      </section>

      {/* This Is Not Just A Website */}
      <section className="wealth-why-section">
        <div className="section-header">
          <h2 className="display-medium section-title">This Is NOT Just A Website</h2>
          <p className="body-large section-description" style={{ maxWidth: '800px', margin: '0 auto' }}>
            This is a fully automated AI credit & funding operation — built under YOUR brand.
          </p>
        </div>
        
        <div className="wealth-why-grid" style={{ maxWidth: '600px', margin: '40px auto' }}>
          <div className="wealth-why-item">
            <div className="wealth-why-icon">
              <Shield size={28} />
            </div>
            <div className="wealth-why-content">
              <h4>You OWN It</h4>
              <p>This is YOUR software, YOUR brand, YOUR business asset</p>
            </div>
          </div>
          <div className="wealth-why-item">
            <div className="wealth-why-icon">
              <Zap size={28} />
            </div>
            <div className="wealth-why-content">
              <h4>You CONTROL It</h4>
              <p>Full control over every aspect of your operation</p>
            </div>
          </div>
          <div className="wealth-why-item">
            <div className="wealth-why-icon">
              <TrendingUp size={28} />
            </div>
            <div className="wealth-why-content">
              <h4>You SCALE It</h4>
              <p>Grow to any size without the growing pains</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="tradelines-cta-section">
        <div className="tradelines-cta-content">
          <h2 className="display-medium">Ready To Build Your Credit Empire?</h2>
          <p className="body-large" style={{ marginBottom: '30px' }}>
            Stop trading time for money. Get a system that works while you sleep.
          </p>
          <a 
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ fontSize: '20px', padding: '20px 50px' }}
          >
            Buy Now <ArrowRight size={24} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default MillionDollarSoftwarePage;
